import { all, call, fork, put, takeEvery } from 'redux-saga/effects';


// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
import { getQuery } from 'Core/data/Helpers';
import moment from 'moment';

import {
    REPORTS_OVERVIEW_LOAD_DATA,
    REPORTS_OVERVIEW_EXECUTE,
    REPORTS_OVERVIEW_EXPORT
} from 'Redux/actionTypes';

import {
    reportsOverviewGetDataResult,
    executeReportResult,
    exportReportResult,
    genericExportSend,
} from 'Redux/actions';

function* getReportLoadDataAsync({ payload }) {
    try {

        const { id, reportKey } = payload;
        let data = {}
        let dataResult = {}
        let GET_DATA = ""
        if (!reportKey) {
            GET_DATA = `
            {
                Report: getReport(id: ${id}) {
                    id
                    reportKey
                    name
                    description
                    platform
                    reportParams {
                        id
                        reportId
                        paramId
                        defaultValue
                        required
                    }
                    status
                    platform
                    properties
                }
            }
            `;

        } else {
            GET_DATA = `
            {
                Report: searchReports (limit: 1, offset: 0, sort: [{ field: name, order: ASC }], conditions : [{ fields: [reportKey], terms: ["${reportKey}"]}]) {
                    items{
                        id
                        reportKey
                        name
                        description
                        platform
                        reportParams {
                            id
                            reportId
                            paramId
                            defaultValue
                            required
                        }
                        status
                        platform
                        properties
                    }
                }
            }
            `;
        }

        data = yield call(
            clientQuery,
            GET_DATA,
            {},
            endpoints.GRAPHQL_GENERAL
        );

        const GET_PARAMS_DATA = `
            {
                Params: searchParams (limit: 300, offset: 0, sort: [{ field: name, order: ASC }], conditions : []) {
                    items {
                        id
                        name
                        type
                        paramKey
                    }
                    total
                }
            }
            `;

        let paramsData = yield call(
            clientQuery,
            GET_PARAMS_DATA,
            {},
            endpoints.GRAPHQL_GENERAL
        );

        if (paramsData.Params.items.length > 0) {
            dataResult.params = paramsData.Params.items;
        } else {
            dataResult.params = [];
        }

        if (!reportKey) {
            //```call action for get common data
            if (data && data.Report && !reportKey) {
                dataResult.report = JSON.parse(JSON.stringify(data.Report));
                if (dataResult?.report?.properties && dataResult?.report?.properties !== "") {
                    dataResult.report.properties = JSON.parse(dataResult.report.properties);
                }

            }
        } else {
            if (data?.Report?.items?.length > 0) {
                dataResult.report = JSON.parse(JSON.stringify(data.Report))
                dataResult.report = dataResult.report.items[0];
                if (dataResult.report.properties !== "")
                    dataResult.report.properties = JSON.parse(dataResult.report.properties);
            }
        }
        yield put(reportsOverviewGetDataResult(dataResult));

    } catch (exc) {

        yield put(reportsOverviewGetDataResult({ error: exc }));
        ExceptionManager(exc, "modules/reports/views/overview/redux/saga/", "getReportLoadDataAsync", true)
    }
}

function* executeReportRequest({ payload }) {
    const { reportId, values, limit, nextToken, oldNextToken } = payload;
    try {

        let paramValues = [];
        let dataResult = {};
        values.map((item, key) => {
            let newItem = { paramValue: item.paramValue, paramKey: item.paramKey }
            paramValues.push(newItem)
        })

        const GET_DATA = `
        
            query ( $id: Int!, $values: [ParamValue]!, $limit: Int, $nextToken: String ) {
                    reportData: executeReport (id: $id, values: $values, limit: $limit, nextToken: $nextToken) {
                        items
                        nextToken
                    }
             }
        
        `;

        let data = yield call(
            clientQuery,
            GET_DATA,
            {
                id: reportId,
                values: paramValues,
                limit: limit,
                nextToken: nextToken || null
            },
            endpoints.GRAPHQL_GENERAL
        );
        dataResult = JSON.parse(JSON.stringify(data));
        //```call action for get common data
        if (dataResult?.reportData?.items) {
            dataResult.reportData.items = JSON.parse(dataResult?.reportData?.items);
            if (typeof dataResult.reportData.items === "string")
                dataResult.reportData.items = JSON.parse(dataResult?.reportData?.items);
            //```call action for return
            yield put(executeReportResult(dataResult, null, oldNextToken || null));
        } else {
            //```call action for return
            yield put(executeReportResult({ reportData: { items: [], total: 0, nextToken: null } }, null, oldNextToken || null));
        }

    } catch (exc) {

        yield put(executeReportResult(null, exc, oldNextToken || null));
        ExceptionManager(exc, "modules/reports/views/overview/redux/saga/", "executeReportRequest", true)
    }
}

function buildExportHeaders(obj, reportProperties, timeZone, lang, messages) {
    let hiddenColumns = [];
    if (reportProperties && reportProperties !== "" && reportProperties.HiddenColumns)
        hiddenColumns = reportProperties.HiddenColumns;

    let columnsNotShown = ["deviceId", "timezone"];
    let keys = Object.keys(obj);
    let headers = [];

    keys.forEach((item, index) => {
        if (columnsNotShown.includes(item)) return;
        let hiddenItem = hiddenColumns.find(x => x === item);
        if (hiddenItem) return;

        let title = item.replace(/\s/g, "");
        title = `report_overview_${title}`;

        headers.push({
            header: messages[title] || messages[item] || item,
            column: `${item}_${index}`,
            functionString: `
                let statusList = ["SAVED", "INACTIVE", "ACTIVE", "sent", "pending"]
                let currentTimezone = '${timeZone}'
                let lang = "${lang}"

                let dateFields = ["lastTimeCreated","created","cardLastReceivedDate","transLastReceivedDate","postDate", "createdDate"]
                let dateTimeFields = ["createdAt","updatedAt","mostRecentMessageTime","date","lastMessageTime", "unitTime", "serverTime", "transactionDate", "dateProcessed", "startDateTime", "endDateTime", "eventDate"]

                function formatDate(date,tz) {
                    let dateToformat = moment(date)
                    let formatted = moment(dateToformat).tz(tz).format("YYYY/MM/DD HH:mm:ss")
                    return formatted;
                }

                function codes (type, lan){
                    let listEn = {
                        0: "Desactivated",
                        1: "Active",
                        2: "Voluntary Suspension",
                        3: "Involuntary Suspension",
                        4: "Cancelled",
                        6: "RMA",
                        20: "Inactive",
                        SAVED: "Saved",
                        INACTIVE: "Inactive",
                        ACTIVE: "Active",
                        sent: "Sent",
                        pending: "Pending"
                    }
                    let listEs = {
                        0: "Desactivado",
                        1: "Activo",
                        2: "Suspensión Voluntaria",
                        3: "Suspensión Involuntaria",
                        4: "Cancelado",
                        6: "RMA",
                        20: "Inactivo",
                        SAVED: "Guardado",
                        INACTIVE: "Inactivo",
                        ACTIVE: "Activo",
                        sent: "Enviado",
                        pending: "Pendiente"
                    }
                    if(lan === "en"){
                        return listEn[type] || listEn[1]
                    } else {
                        return listEs[type] || listEs[1]
                    }
                }
                if (!isNaN(row['${item}']) && typeof row['${item}'] === 'number' && ${title.toLowerCase().includes("status")}) {
                    return codes(row['${item}'], lang)
                } else if (${title.toLowerCase().includes("status")} && statusList.includes(row['${item}'])){
                    return codes(row['${item}'], lang)
                } else if(dateFields.includes('${item}')){
                    return row['${item}'] ? moment(row['${item}']).utc().format('YYYY/MM/DD') : ""
                } else if(dateTimeFields.includes('${item}')){
                    return row['${item}'] ? formatDate(row['${item}'],row?.timezone || currentTimezone) : ''
                } else if('${item}' === 'cardNumber'){
                    return "*"+ row['${item}'] + "*"
                } else {
                    return row['${item}'] || ''
                }
            `
        });
    });

    return headers;
}

function* exportReportRequest({ payload }) {
    try {
        const { reportId, values, format, reportProperties, timeZone, lang, messages, reportName, limit } = payload;

        let paramValues = values.map(item => ({
            paramValue: item.paramValue,
            paramKey: item.paramKey
        }));

        // Fetch a single item to discover column names
        const DISCOVER_QUERY = `
            query ($id: Int!, $values: [ParamValue]!, $limit: Int, $nextToken: String) {
                reportData: executeReport(id: $id, values: $values, limit: $limit, nextToken: $nextToken) {
                    items
                    nextToken
                }
            }
        `;

        let data = yield call(
            clientQuery,
            DISCOVER_QUERY,
            {
                id: reportId,
                values: paramValues,
                limit: 1,
                nextToken: null
            },
            endpoints.GRAPHQL_GENERAL
        );

        let items = data?.reportData?.items;
        if (typeof items === "string") items = JSON.parse(items);
        if (typeof items === "string") items = JSON.parse(items);

        if (!items || items.length === 0) {
            yield put(exportReportResult(null, { message: messages["report_overview_no_data"] || "No data available for export" }));
            return;
        }

        let headers = buildExportHeaders(items[0], reportProperties, timeZone, lang, messages);

        if (headers.length === 0) {
            yield put(exportReportResult(null, { message: messages["report_overview_no_data"] || "No data available for export" }));
            return;
        }

        let query = getQuery("report");
        let graphqlVariables = {
            id: reportId,
            values: paramValues,
            limit: limit || 100,
            nextToken: null
        };
        
        let currentType = format === 'CSV' ? 'Csv' : 'Pdf';

        yield put(genericExportSend(
            currentType,
            query,
            graphqlVariables,
            headers,
            { unit: 'pt', size: 'A4', orientation: 'portrait', fontSize: 12 },
            false,
            true,
            null,
            `Report_${reportName}_${moment().unix()}`,
            null,
            limit || 100
        ));

        yield put(exportReportResult({ success: true }));

    } catch (exc) {
        yield put(exportReportResult(null, exc));
        ExceptionManager(exc, "modules/reports/views/overview/redux/saga/", "exportReportRequest", true);
    }
}

export function* watchMethods() {
    yield takeEvery(REPORTS_OVERVIEW_LOAD_DATA, getReportLoadDataAsync);
    yield takeEvery(REPORTS_OVERVIEW_EXECUTE, executeReportRequest);
    yield takeEvery(REPORTS_OVERVIEW_EXPORT, exportReportRequest);
}

export default function* rootSaga() {
    yield all([
        fork(watchMethods)
    ]);
}